import { Text, H1, Box } from 'components'
import styled from '@emotion/styled'
import { ThemeProvider } from '@emotion/react'
import { BOXSHADOWS, COLORS, GlobalStyles, theme } from 'utils'
import { rem } from 'polished'
import UITheme from '@nextretreat/ui-components/dist/Theme'
import { ReactComponent as LogoIcon } from 'assets/images/svg/logo-next-retreat.svg'

const RootWrapper = styled(Box)`
  background-color: ${UITheme.COLORS.WHITE};
  box-shadow: ${BOXSHADOWS.DARK};
  border-radius: 8px;
  border: 1px solid ${COLORS.IRRADIANT_IRIS};
  max-width: 100%;
  width: ${rem(500)};
  padding: ${rem(40)};
  overflow: auto;
  margin-bottom: 20px;
`

export const Logo = styled(LogoIcon)`
  height: ${rem(80)};
  width: ${rem(250)};
  margin-bottom: ${rem(20)};
`

export const ErrorFallback = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />

      <RootWrapper>
        <Logo />

        <H1>Error occured</H1>

        <Text as="p" textAlign="center" marginBottom={30}>
          To make your experience as good as we can we are currentlly fixing
          this error. Until then you can visit us at{' '}
          <a href="https://www.nextretreat.com/">NextRetreat.com</a>
        </Text>
      </RootWrapper>
    </ThemeProvider>
  )
}
